import React, { useContext } from 'react';
import { Modal as ModalModule } from 'common';
import isFunction from 'lodash/isFunction';

import ContactsCommunication from '../utils/ContactsCommunication';

const { Modal, ModalButtonActionType, ModalContext } = ModalModule;

const DeleteGroupModal = ({ modalId, data: { selectedGroup, manageGroupsDeleteCallback } }) => {
	const { showError, closeModal } = useContext(ModalContext);

	const onPrimaryButtonClick = async () => {
		const response = await ContactsCommunication.deleteGroup(selectedGroup.id);

		if (ContactsCommunication.isSuccessful(response)) {
			// callback from ManageGroup to refresh Groups grid
			if (isFunction(manageGroupsDeleteCallback)) {
				manageGroupsDeleteCallback(selectedGroup.id);
			}

			closeModal(modalId, ModalButtonActionType.Ok, true);
		} else {
			showError({ response });
		}
	};

	const primaryButton = {
		type: ModalButtonActionType.Ok,
		text: 'Yes',
		onClick: onPrimaryButtonClick,
		dataqa: 'delete-group-yes-button',
	};

	const secondaryButton = {
		type: ModalButtonActionType.Cancel,
		text: 'No',
		dataqa: 'delete-group-no-button',
	};

	return (
		<Modal
			modalId={modalId}
			className="contacts contacts-delete-group-modal warning-modal"
			header="Delete Group"
			primaryButton={primaryButton}
			secondaryButton={secondaryButton}
			size="small"
		>
			<div className="body">
				<p>{`Delete Group "${selectedGroup.name}"`}</p>
			</div>
		</Modal>
	);
};

export default DeleteGroupModal;
